module.exports = __webpack_public_path__ + "assets/img/login-bg.54ce0555.png";